/*
 * One button vocabulary for the reservation details page, so every action reads as part of the
 * same design instead of each card inventing its own:
 *
 * - Primary: the one next step for the reservation (start / end it). antd `type="primary"`.
 * - Soft: frequent actions on the booking itself (extend, swap car) — tinted so they are easy to
 *   spot without competing with the primary step.
 * - Secondary: everything else (invoice, extra charge, refund, profile).
 * - Danger: destructive actions, antd `danger`, same shape as the rest.
 *
 * Two heights: `ACTION_SIZE_LG` for page-level actions, `ACTION_SIZE_SM` inside cards.
 */

const BASE = "!rounded-lg !text-sm !font-medium !shadow-none";

export const ACTION_SIZE_LG = `${BASE} !h-10 !px-4`;
export const ACTION_SIZE_SM = `${BASE} !h-9 !px-3.5`;

export const SECONDARY_ACTION =
    "!border-[#E4E4EE] !bg-white !text-[#2F2F46] hover:!border-[#5D5DF6] hover:!text-[#5D5DF6] disabled:!border-[#f0f0f0] disabled:!bg-[#FAFAFA] disabled:!text-[#bfbfbf]";

export const SOFT_ACTION =
    "!border-[#5D5DF6]/20 !bg-[#F2F2FA] !text-[#5D5DF6] hover:!border-[#5D5DF6] hover:!bg-[#EAEAFB] hover:!text-[#5D5DF6]";
